import {
    FETCH_DASHBOARD_COUNT_REQUEST,
    FETCH_DASHBOARD_COUNT_SUCCESS,
    FETCH_DASHBOARD_COUNT_FAILURE,
    FETCH_DASHBOARD_USAGE_REQUEST,
    FETCH_DASHBOARD_USAGE_SUCCESS,
    FETCH_DASHBOARD_USAGE_FAILURE
} from '../actions/dashboardAction';

const initialState = {
    count: null,
    usage: null,
    loading: false,
    error: null
};

const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DASHBOARD_COUNT_REQUEST:
        case FETCH_DASHBOARD_USAGE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case FETCH_DASHBOARD_COUNT_SUCCESS:
            return {
                ...state,
                count: action.payload,
                loading: false
            };
            
        case FETCH_DASHBOARD_USAGE_SUCCESS:
            return {
                ...state,
                usage: action.payload,
                loading: false
            };

        case FETCH_DASHBOARD_COUNT_FAILURE:
        case FETCH_DASHBOARD_USAGE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
            
        default:
            return state;
    }
};

export default dashboardReducer;
